import React from 'react';

import { useUIContext } from 'lib/context/UIContext/UIContext';

import Breadcrumb from 'components/shared/Breadcrumb/Breadcrumb';
import Button from 'components/shared/Button/Button';
import Typography from 'components/shared/Typography/Typography';

const ModalHeader = ({
  setDetails,
  selectedData,
  breadcrumb,
  tab,
  lockNext,
  disableClick,
  headerActions,
  hasBackButton,
  trimSteps
}) => {
  const { device } = useUIContext();
  const isDesktop = device === 'desktop' || device === 'laptop';
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  const Actions = headerActions || null;

  const finalTitle = breadcrumb.current?.headerTitle ?? breadcrumb.current?.title;

  return (
    <div className="flex w-full items-center justify-between gap-4">
      <div className="flex gap-3 sm:flex-col xs:flex-col">
        {finalTitle &&
          (isMobile ? (
            <Typography variant="p" size="small" className="text-neutral-800">
              {finalTitle}
            </Typography>
          ) : (
            <p className="whitespace-nowrap text-sm font-medium text-neutral-800">{finalTitle}</p>
          ))}
        {breadcrumb?.steps?.length > 1 && (
          <Breadcrumb
            textClassName="text-sm text-neutral-800 "
            splitType="slash"
            data={selectedData}
            lockNext={lockNext}
            breadcrumb={breadcrumb}
            disableClick={disableClick}
            hasBackButton={hasBackButton}
            trimSteps={trimSteps}
          />
        )}
      </div>
      <div className="flex items-center gap-2">
        {headerActions && <Actions breadcrumb={breadcrumb} />}
        {tab?.details?.alwaysShow && !isDesktop && (
          <Button
            variant="link"
            icon="document-preview-mono"
            iconColor="neutral"
            iconSize={16}
            className="h-full"
            onClick={() => setDetails(true)}
          />
        )}
      </div>
    </div>
  );
};

export default ModalHeader;
